import React from 'react';
import './index.scss';

const Loading = () => <div className="loader-wrapper">
  <div className="loader">Loading...</div>
</div>;

export default Loading;